module.exports = __webpack_public_path__ + "img/hero-transformer.b4aad43b.jpg";